/**
 * useOperatorQueue — F-007 Phase 4 (IMPL-P4-004).
 *
 * Polling della coda operatore con TanStack Query v5 (object syntax).
 *  - Auto-refetch ogni 15s (`refetchInterval`) → "heartbeat" UX.
 *  - Refetch al focus della finestra → l'operatore vede subito gli arrivi
 *    quando torna sulla tab.
 *
 * Query key: `['operator', 'queue', page, pageSize]` per consentire
 * invalidazione targettata da `useTakeInCarico` e `useReleaseInCarico`.
 */
import { useQuery } from '@tanstack/react-query';
import { operatorClient } from '../lib/operator-client';

export function useOperatorQueue(page = 1, pageSize = 20) {
  return useQuery({
    queryKey: ['operator', 'queue', page, pageSize] as const,
    queryFn: () => operatorClient.listQueue({ page, pageSize }),
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  });
}
